import React from "react";
import toast from "react-hot-toast";

/**
 * Custom confirmation toast using react-hot-toast.
 * Returns a Promise that resolves to true (Confirmed) or false (Cancelled).
 *
 * @param {string} message The custom message to display in the toast.
 * @param {object} options Customization options (confirmText, cancelText, confirmColor, cancelColor, position, etc.)
 * @returns {Promise<boolean>}
 */
export const showConfirmationToast = (message, options = {}) => {
  const {
    confirmText = "Confirm",
    cancelText = "Cancel",
    confirmColor = "bg-indigo-600 hover:bg-indigo-700 text-white",
    cancelColor = "bg-gray-100 hover:bg-gray-200 text-gray-800",
    position = "top-center",
  } = options;

  return new Promise((resolve) => {
    const toastId = toast(
      (t) => (
        <div className="flex flex-col gap-3 p-1 min-w-[250px]">
          <div className="text-sm font-semibold text-gray-800 leading-relaxed">
            {message}
          </div>
          <div className="flex justify-end gap-2 mt-1">
            <button
              onClick={() => {
                toast.dismiss(t.id);
                resolve(false);
              }}
              className={`px-3 py-1.5 text-xs font-semibold rounded transition-all duration-150 ${cancelColor}`}
            >
              {cancelText}
            </button>
            <button
              onClick={() => {
                toast.dismiss(t.id);
                resolve(true);
              }}
              className={`px-3 py-1.5 text-xs font-semibold rounded shadow-sm transition-all duration-150 ${confirmColor}`}
            >
              {confirmText}
            </button>
          </div>
        </div>
      ),
      {
        id: options.id || "confirmation-toast",
        duration: Infinity,
        position: position,
      }
    );
  });
};
